// List of betting providers and their logos/urls.
// Update logos to your actual paths under public/ or CDN links.
const bettingProviders = [
  { id: 'pmu', name: 'PMU.fr', logo: '/providers/pmu.png', url: 'https://www.pmu.fr', allowsIframe: true },
  { id: 'winamax', name: 'Winamax', logo: '/providers/winamax.png', url: 'https://www.winamax.fr', allowsIframe: false },
  { id: 'parionssport', name: 'Parions Sport', logo: '/providers/parions-sport.png', url: 'https://www.enligne.parionssport.fdj.fr', allowsIframe: false },
  { id: 'unibet', name: 'UNIBET', logo: '/providers/unibet.png', url: 'https://www.unibet.fr', allowsIframe: false },
  { id: 'bwin', name: 'Bwin', logo: '/providers/bwin.png', url: 'https://www.bwin.fr', allowsIframe: false },
  { id: 'betsson', name: 'Betsson', logo: '/providers/betsson.png', url: 'https://www.betsson.com', allowsIframe: false },
];

export default bettingProviders;

